export default __webpack_public_path__ + "static/media/sa2.48da1b4b.jpg";